// @ts-ignore
import * as Bond from "@airdao/airdao-bond";
import {Notify} from '@airdao/ui-library';
import axios from 'axios';
// @ts-ignore
import * as BondOld from 'airdao-bond-old';
import { AmbErrorProviderWeb3 } from '@airdao/airdao-node-contracts';

const env = {
  '16718': 'main',
  '22040': 'test',
  '30746' : 'dev',
};

export const claimBond = async (contracts: any, contractName: string, arg1: string = '', arg2: string, hash: string, account: string, deleteLoading: (hash: string) => void, version: string, provider: any, setClaimedOrders: (hash: string) => void) => {
  const errorProvider = new AmbErrorProviderWeb3(provider?.provider);
  const signer = errorProvider.getSigner();

  Notify.loading('Transaction in progress.',null,  {toastId: "claim-loading"});
  // @ts-ignore
  const contractsOld = new BondOld.Contracts(signer, env[process.env.REACT_APP_CHAIN_ID]);
  const contract = version === 'v1' ? BondOld : Bond;
  try {
    const tx = await contract.Methods[contractName === 'BondFixedTermTeller' ? 'bondFixedTermTellerRedeem' : 'bondFixedExpiryTellerRedeem'](
      version === 'v1' ? contractsOld : contracts,
      contractName,
      arg1,
      arg2
    );
    if (contractName !== 'BondFixedTermTeller') {
      setExpiryClaimed(account, hash);
    }
    await tx.wait();
    deleteLoading(hash);
    setClaimedOrders(hash);
    Notify.success('Success', null, {autoClose: 5000});
    Notify.dismiss('claim-loading');
  } catch (e: any) {
    deleteLoading(hash)
    console.log(e);
    console.error('claim bond error', e);
    if (e.code !== 'ACTION_REJECTED') {
      Notify.error('Error', null, {autoClose: 5000});
    }
    Notify.dismiss('claim-loading');
    throw new Error(e);
  }
};

export const getExpiryClaimed = (address: string) => {
  return axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/orders/${address}`);
};

const setExpiryClaimed = (userAddress: string, txHash: string) => {
  axios.post(`${process.env.REACT_APP_BACKEND_URL}/v2/api/orders/`, {
    userAddress, txHash
  })
}